<style lang="scss">
$teal:      #5bb8b1;
$teal-dark: #2c7d76;
$teal-bg:   #e4f3f0;
$dark:      #1a1a2e;
$gray:      #6c7280;

#confirm-form {
  .form-control { height: 40px; }

  .alert-dotted {
    border: 2px dotted rgba(91, 184, 177, 0.4);
    border-radius: 10px;
    background: rgba(91, 184, 177, 0.04);
  }

  .confirm-msg { margin-bottom: 150px; }

  .list-unstyled {
    li {
      padding: 8px 0;
      border-bottom: 1px solid rgba(91, 184, 177, 0.1);

      &:last-child { border-bottom: none; }

      label {
        font-size: 13px;
        color: $gray;
        margin: 0;
      }

      .detail {
        font-size: 14px;
        font-weight: 700;
        color: $dark;
        margin-left: 6px;
      }
    }
  }

  /* Confirm checkbox row */
  li.mt-5 {
    display: flex !important;
    align-items: flex-start;
    gap: 10px;
    padding: 14px 0 !important;

    input[type="checkbox"] {
      width: 18px;
      height: 18px;
      flex-shrink: 0;
      accent-color: $teal;
      margin-top: 2px;
    }

    label {
      font-size: 14px !important;
      font-weight: 600 !important;
      color: $dark !important;
      margin: 0 !important;
      line-height: 1.5;
    }
  }
}
</style>
<template>
  <section id="confirm-form">
    <div class="row">
      <div class="col-lg-12">
        <h5 class="mb-5">Confirm Details</h5>
        <div class="row">
          <div class="col-md-12">
            <div
              class="
                alert alert-custom alert-danger-dim alert-shadow
                fade
                show
                gutter-b
              "
              v-if="getSettingNote.appointment_confirm_detail_note != ''"
              role="alert"
            >
              <div class="alert-text">
                <div
                  v-html="getSettingNote.appointment_confirm_detail_note"
                ></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12">
        <ul class="list-unstyled">
          <li>
            <label for="">First Name:</label>
            <label for="" class="detail">{{ getApplicantFirstName }}</label>
          </li>
          <li v-if="getApplicantMiddleName != ''">
            <label for="">Middle Name: </label>
            <label for="" class="detail">{{ getApplicantMiddleName }}</label>
          </li>

          <li>
            <label for="">Last Name: </label>
            <label for="" class="detail">{{ getApplicantlastName }}</label>
          </li>
          <li v-if="!disablePII">
            <label for="">Social Security No.:</label>
            <label for="" class="detail">{{
              getApplicantSSN != "" ? getApplicantSSN : "None"
            }}</label>
          </li>
          <li v-if="!disablePII">
            <label for="">Date of Birth: </label>
            <label for="" class="detail">{{
              getApplicantDateOfBirth | dateOfBirthFormat
            }}</label>
          </li>
          <li class="mt-5" style="display:inline-flex">
            <input
              type="checkbox"
              v-model="sms_status"
              @change="updateSmsStstus"
              name=""
              id="sms_status"
            />
            <label
              for="sms_status"
              class="ml-2"
              style="font-size:16px;font-weight:600;margin-top:8px"
              >I would like to confirm the details related to my
              appointment</label
            >
          </li>
        </ul>
      </div>
    </div>
    <div class="row confirm-msg">
      <div class="col-md-12">
        <div
          class="
                alert alert-custom alert-dotted alert-shadow
                fade
                show
                gutter-b
              "
          role="alert"
          v-if="getSettingNote.appointment_shipping_note != ''"
        >
          <div class="alert-text">
            <div v-html="getSettingNote.appointment_shipping_note"></div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
import { mapGetters } from "vuex";
import moment from "moment";
// import Title from '../../components/frontend/title.vue';
// import moment from "moment";
import { SET_SMS_STATUS } from "@/core/services/store/mutations.type";
export default {
  props: {
    disablePII: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    ...mapGetters([
      "getApplicantFirstName",
      "getApplicantlastName",
      "getApplicantSSN",
      "getApplicantDateOfBirth",
      "getSettingNote",
      "getSmsStatus",
      "getApplicantMiddleName"
    ])
  },
  data() {
    return {
      sms_status: false
    };
  },
  created() {
    this.sms_status = this.getSmsStatus;
  },
  methods: {
    updateSmsStstus() {
      // alert(this.sms_status);
      // alert(e.target.value);
      this.$store.commit(SET_SMS_STATUS, this.sms_status);
      this.sms_status = this.getSmsStatus;
    }
  },
  filters: {
    dateOfBirthFormat(value) {
      return moment(value).format("MM/DD/YYYY");
    }
  }
};
</script>
